// extracted by mini-css-extract-plugin
export var infoItem = "_tj-2";
export var title = "_tj-0";
export var value = "_tj-1";